module.exports = __webpack_public_path__ + "img/chinesecompany140.f151ed62.png";